import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, ArrowRight, CheckCircle2 } from "lucide-react";
import { api, apiErr } from "../api";
import { AuthShell } from "./Login";

const Field = ({ icon: Icon, ...props }) => (
  <div className="relative">
    <Icon size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500" />
    <input {...props} className="cc-input w-full rounded-xl pl-10 pr-4 py-3 text-sm" />
  </div>
);

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      toast.error(apiErr(e.response?.data?.detail) || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="We'll email you a secure reset link"
      footer={<><Link to="/credit/login" className="text-blue-300 hover:text-blue-200">Back to login</Link></>}
    >
      {sent ? (
        <div className="text-center" data-testid="forgot-sent">
          <CheckCircle2 size={40} className="mx-auto text-emerald-400" />
          <p className="text-slate-300 text-sm mt-4">
            If an account exists for <span className="text-white">{email}</span>, a reset link is on its way. Check your inbox (and spam).
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-3.5">
          <Field icon={Mail} type="email" required placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
          <button type="submit" disabled={loading} data-testid="forgot-submit" className="cc-btn-primary flex w-full items-center justify-center gap-2 rounded-xl py-3 text-sm font-500 disabled:opacity-60">
            {loading ? "Sending…" : <>Send reset link <ArrowRight size={16} /></>}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
